"use strict";

module.exports = function getFileReaderMethodName(readAs) {
  var _window = window,
      FileReader = _window.FileReader;
  /* istanbul ignore if  */

  if (typeof FileReader === 'undefined') {
    throw Error('FileReader is not supported by this browser');
  }

  var methodName = "readAs".concat(readAs[0].toUpperCase()).concat(readAs.slice(1));

  if (!FileReader.prototype[methodName]) {
    throw Error("Method ".concat(methodName, " is not supported by FileReader"));
  }

  return methodName;
};